export default class FieldIndexer {
    constructor({fields, helpers}) {
        this.index = {};
        this.labels = {};
        this.buildIndex(fields, helpers);
    }

    static isSpecialKey(key) {
        // special keys start with $
        // e.g. $nested, $description
        return key.charAt(0) === '$';
    }

    /**
     * Build a flat index of all unique keys and
     * aggregate all their known pathways
     * @param pathways
     */
    buildIndex(pathways, helpers) {
        const parse = (root, fields, lineage) => {
            const keys = Object.keys(fields);
            keys.forEach((prop) => {
                // user lowercase to make index keys
                // case-insensitive
                const lowerProp = prop.toLowerCase();
                const field = fields[prop];
                const fullPath = `${root}/${prop}`;
                if (field.$nested) {
                    // parse nested properties from a new root
                    parse(fullPath, field, lineage.concat(prop));
                } else if (!FieldIndexer.isSpecialKey(prop)) {
                    if (!Reflect.has(this.index, lowerProp)) {
                        this.index[lowerProp] = {};
                    }
                    const groupLineage = lineage.map(step => this.resolveLabel(step, helpers));
                    const label = this.resolveLabel(prop, helpers);
                    this.index[lowerProp][root] = {
                        field,
                        fullPath,
                        group: root,
                        groupLineage,
                        label,
                        lineage: groupLineage.concat(label),
                        prop,
                    };
                }
            });
        };
        // start parsing at the root recursively
        Object.keys(pathways)
            .forEach((group) => {
                const {fields, lineage} = pathways[group];
                parse(group, fields, lineage);
            });
        this.indexKeys = Object.keys(this.index);
    }

    resolveLabel(prop, helpers) {
        if (!Reflect.has(this.labels, prop)) {
            this.labels[prop] = helpers.unCamelCase(prop);
        }
        return this.labels[prop];
    }
}
